module.exports = __webpack_public_path__ + "static/img/ipad-sns.27a55d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ipad-sns.png
// module id = CuWH
// module chunks = 1